import { API } from "aws-amplify";
import React, { useState } from "react";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Card, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import swal from "sweetalert";
import Spinner from "../../components/Spinner";
import { FormError, getTier, handleApiError, isViewer } from "../../helpers";
import PackageCount from '../../data/packageCount.json';
import StorageType from '../../data/storage-type.json';
import toast from "react-hot-toast";

const PackageSection = ({ packages, packageCount, handleItems, myShipper, myShippers, handlePackages, scanPackageData, packageErrors, setPackageErrors, updateShipmentFunc, shipmentUpdate, showEditButtons, hideName, shipperSettings, isColdChain, greenPhox }) => {

    const [editItemModal, openEditItemModal] = useState(false);
    const [newItem, setNewItem] = useState({});
    const [newItemErrors, setNewItemErrors] = useState({})
    const [customNDC, addCustomNDC] = useState(false)
    const [spinner, showSpinner] = useState(false)

    const onDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) return;
        const sourcePackageIndex = parseInt(source.droppableId, 10);
        const destinationPackageIndex = parseInt(destination.droppableId, 10);
        const sourceItemIndex = source.index;
        const destinationItemIndex = destination.index;

        let updatedPackages = packages.map(pkg => ({
            ...pkg,
            items: [...pkg.items]
        }));

        const draggedItem = updatedPackages[sourcePackageIndex].items[sourceItemIndex];
        updatedPackages[sourcePackageIndex]?.items?.splice(sourceItemIndex, 1);
        updatedPackages[destinationPackageIndex]?.items?.splice(destinationItemIndex, 0, draggedItem);

        updatedPackages = updatedPackages?.filter((pkg) => pkg?.items?.length > 0)
        const updatedPackageCount = updatedPackages.length;
        handlePackages(updatedPackages, updatedPackageCount);
        if (shipmentUpdate) {
            updateShipmentFunc(updatedPackages);
        }
        if (packageErrors?.length > 0 && scanPackageData) {
            let errorList = [];
            const numberMap = new Map()
            updatedPackages?.forEach((pkg, pkgIndex) => {
                pkg?.items?.forEach((item, itemIndex) => {
                    let errors = {};
                    if (item?.name === "Drug") {
                        if (!item.number || item.number.trim() === '') {
                            errors.number = 'required';
                        }
                        if (!item.description || item.description.trim() === '') {
                            errors.description = 'required';
                        }
                        if (!item.ndc || item.ndc.trim() === '') {
                            errors.ndc = 'required';
                        }
                        if (!item.quantity || item.quantity.trim() === '') {
                            errors.quantity = 'required';
                        }
                    }
                    const refNumber = item?.number;
                    if (refNumber && numberMap.has(refNumber)) {
                        errors.duplicateReferenceNumber = 'Duplicate reference number.';
                    } else if (refNumber) {
                        numberMap.set(refNumber, { pkgIndex, itemIndex });
                    }

                    if (Object.keys(errors).length > 0) {
                        errorList.push({ pkgIndex, itemIndex, errors });
                    }
                });
            });
            setPackageErrors(errorList);
        };
    }

    const validatePackageData = () => {
        if (!scanPackageData) return;
        let errorList = [];
        const numberMap = new Map();
        packages?.items?.forEach((pkg, pkgIndex) => {
            pkg?.items?.forEach((item, itemIndex) => {
                let errors = {};
                if (item?.name === "Drug") {
                    if (!item.number || item.number.trim() === '') {
                        errors.number = 'required';
                    }
                    if (!item.description || item.description.trim() === '') {
                        errors.description = 'required';
                    }
                    if (!item.ndc || item.ndc.trim() === '') {
                        errors.ndc = 'required';
                    }
                    if (!item.quantity || item.quantity.trim() === '') {
                        errors.quantity = 'required';
                    }
                }
                const refNumber = item?.number;
                if (refNumber && numberMap.has(refNumber)) {
                    errors.duplicateReferenceNumber = 'Duplicate reference number.';
                } else if (refNumber) {
                    numberMap.set(refNumber, { pkgIndex, itemIndex });
                }

                if (Object.keys(errors).length > 0) {
                    errorList.push({ pkgIndex, itemIndex, errors });
                }
            });
        });
        setPackageErrors(errorList);
    };

    const removeShipmentItem = (index, key) => {
        const newItems = packages.map(pkg => ({
            ...pkg,
            items: [...pkg.items]
        }));;
        newItems[key] = newItems[key] || [];
        newItems[key]?.items?.splice(index, 1);
        if (shipmentUpdate) {
            swal({
                text: `Are you sure you want to continue?`,
                buttons: ['No', 'Yes'],
                icon: 'error',
                dangerMode: true,
            }).then(async (status) => {
                if (status) {
                    updateShipmentFunc(newItems)
                    if (scanPackageData) {
                        let errorList = [];
                        const numberMap = new Map()
                        newItems?.forEach((pkg, pkgIndex) => {
                            pkg?.items?.forEach((item, itemIndex) => {
                                let errors = {};
                                if (item?.name === "Drug") {
                                    if (!item.number || item.number.trim() === '') {
                                        errors.number = 'required';
                                    }
                                    if (!item.description || item.description.trim() === '') {
                                        errors.description = 'required';
                                    }
                                    if (!item.ndc || item.ndc.trim() === '') {
                                        errors.ndc = 'required';
                                    }
                                    if (!item.quantity || item.quantity.trim() === '') {
                                        errors.quantity = 'required';
                                    }
                                }
                                const refNumber = item?.number;
                                if (refNumber && numberMap.has(refNumber)) {
                                    errors.duplicateReferenceNumber = 'Duplicate reference number.';
                                } else if (refNumber) {
                                    numberMap.set(refNumber, { pkgIndex, itemIndex });
                                }

                                if (Object.keys(errors).length > 0) {
                                    errorList.push({ pkgIndex, itemIndex, errors });
                                }
                            });
                        });
                        setPackageErrors(errorList);
                    }
                }
            });
        } else {
            handleItems(newItems)
            if (scanPackageData) {
                let errorList = [];
                const numberMap = new Map()
                newItems?.forEach((pkg, pkgIndex) => {
                    pkg?.items?.forEach((item, itemIndex) => {
                        let errors = {};
                        if (item?.name === "Drug") {
                            if (!item.number || item.number.trim() === '') {
                                errors.number = 'required';
                            }
                            if (!item.description || item.description.trim() === '') {
                                errors.description = 'required';
                            }
                            if (!item.ndc || item.ndc.trim() === '') {
                                errors.ndc = 'required';
                            }
                            if (!item.quantity || item.quantity.trim() === '') {
                                errors.quantity = 'required';
                            }
                        }
                        const refNumber = item?.number;
                        if (refNumber && numberMap.has(refNumber)) {
                            errors.duplicateReferenceNumber = 'Duplicate reference number.';
                        } else if (refNumber) {
                            numberMap.set(refNumber, { pkgIndex, itemIndex });
                        }

                        if (Object.keys(errors).length > 0) {
                            errorList.push({ pkgIndex, itemIndex, errors });
                        }
                    });
                });
                setPackageErrors(errorList);
            }
        }

    };

    const removePackage = async (key, newItems) => {
        swal({
            text: `You will lose the Package data if you continue. Are you sure you want to continue?`,
            buttons: ['No', 'Yes'],
            icon: 'error',
            dangerMode: true,
        }).then(async (status) => {
            if (status) {
                while (newItems.length > key) {
                    newItems.pop();
                }
                handlePackages(newItems, PackageCount[key]);
            }
        });
    };

    const handlePackageCount = (key) => {
        const currentItems = packages.map(pkg => ({
            ...pkg,
            items: [...pkg.items]
        })) || [];
        const currentItemsCount = currentItems.length;
        let newItems = [...currentItems];
        let storageType = "ROOM_TEMPERATURE";
        if (greenPhox) {
            storageType = 'COLD_CHAIN'
        }
        const coldChain = shipperSettings?.findIndex(x => x.key === 'shipment_cold_chain_required') || isColdChain
        if (coldChain >= 0 && shipperSettings[coldChain].value === 'Yes') {
            storageType = 'COLD_CHAIN'
        }

        if (currentItemsCount > key) {
            const hasValueInRemovedArray = currentItems[key]?.items?.some((item) => item.number !== '');
            if (hasValueInRemovedArray) {
                removePackage(key, newItems);
                return;
            } else {
                while (newItems.length > key) {
                    newItems.pop();
                }
                handlePackages(newItems, PackageCount[key]);
            }

            let errorList = [];
            const numberMap = new Map();
            newItems.forEach((pkg, pkgIndex) => {
                pkg?.items?.forEach((item, itemIndex) => {
                    let errors = {};
                    const refNumber = item.number;
                    if (refNumber && numberMap.has(refNumber)) {
                        errors.duplicateReferenceNumber = 'Duplicate reference number.';
                    } else if (refNumber) {
                        numberMap.set(refNumber, { pkgIndex, itemIndex });
                    }
                    if (Object.keys(errors).length > 0) {
                        errorList.push({ pkgIndex, itemIndex, errors });
                    }
                });
            });
            setPackageErrors(errorList);

        }
        let packageItem = scanPackageData ? [{ id: 'NEW', name: "Drug", number: "", tier: 0, description: "", unit: "EA", ndc: "", quantity: "", isNew: shipmentUpdate ? true : false }] : [{ id: 'NEW', name: "Drug", number: "", isNew: shipmentUpdate ? true : false }]
        let count = packages?.length
        while (newItems.length < key) {
            count = count + 1
            newItems.push(
                {
                    name: `Package${count}`,
                    package_type: storageType,
                    items: packageItem
                },
            );
        }
        handlePackages(newItems, PackageCount[key]);
    };

    const searchProducts = async (keyword) => {
        try {
            const apiName = 'api';
            const path = `/search/product?size=1000&from=0`;
            const init = {
                body: {
                    "sort": [
                        {
                            "name.keyword": {
                                "order": "asc"
                            }
                        }
                    ],
                    "query": {
                        "bool": {
                            "must": [
                                {
                                    "match": {
                                        "shipperId": myShipper?.shipper?.id || myShippers[0]?.shipper?.id
                                    }
                                }
                            ]
                        }
                    }
                },
            };
            if (keyword) {
                let fields = ["name"]
                init.body.query.bool.must.push(
                    {
                        "multi_match": {
                            "query": keyword,
                            "fields": fields
                        }
                    }
                )
            }
            const { hits } = await API.post(apiName, path, init);
            const sourceData = hits?.hits?.length > 0 ? hits?.hits?.map((item) => item?._source) : [];
            sourceData?.unshift({ id: 'NEW', name: "Drug" });
            return sourceData.map((item) => ({
                value: item.id,
                label: item.name,
            }));
        } catch (error) {
            handleApiError(error)
        }
    };

    const removePackages = (index) => {
        const hasValueInRemovedArray = packages[index]?.items?.some((item) => item.number !== '');
        const confirmAndRemovePackage = () => {
            let newItems = [...packages];
            newItems.splice(index, 1);
            const updatedErrors = packageErrors.filter((error) => error.pkgIndex !== index);
            const shiftedErrors = updatedErrors.map((error) =>
                error.pkgIndex > index ? { ...error, pkgIndex: error.pkgIndex - 1 } : error
            );

            setPackageErrors(shiftedErrors);
            if (shipmentUpdate) {
                updateShipmentFunc(newItems, newItems.length)
            } else {
                handlePackages(newItems, newItems.length);
            }
        };
        if (hasValueInRemovedArray || shipmentUpdate) {
            swal({
                text: `You will lose the Package data if you continue. Are you sure you want to continue?`,
                buttons: ['No', 'Yes'],
                icon: 'error',
                dangerMode: true,
            }).then(async (status) => {
                if (status) {
                    confirmAndRemovePackage();
                }
            });
        } else {
            confirmAndRemovePackage();
        }
    };

    const getErrorMessage = (pkgIndex, itemIndex, field) => {
        const error = packageErrors?.find((err) => err.pkgIndex === pkgIndex && err.itemIndex === itemIndex);
        return error?.errors[field] || '';
    };

    const getErrorMessageForRow = (pkgIndex, itemIndex) => {
        const error = packageErrors?.find((err) => err.pkgIndex === pkgIndex && err.itemIndex === itemIndex);
        return error ? true : false;
    };

    const validateItem = () => {
        let errors = {};
        let isDuplicate = false;
        packages.forEach((pkg, pkgIndex) => {
            pkg?.items?.forEach((item, itemIndex) => {
                const refNumber = item?.number?.trim();
                if (!refNumber) return;
                if (newItem?.number?.trim() === refNumber && !(newItem?.index == itemIndex && newItem?.key == pkgIndex)) {
                    isDuplicate = true;
                }
            });
        });
        if (isDuplicate) { errors.number = 'Reference number already in use.' }
        if (scanPackageData && newItem?.name === 'Drug') {
            if (!newItem.number?.trim()) errors.number = "required";
            if (!newItem.ndc) errors.ndc = "required";
            if (!newItem.quantity?.trim()) errors.quantity = "required";
            if (!newItem.description?.trim()) errors.name = "Name is required";
        }
        setNewItemErrors(errors);
        return errors
    }

    const handleAddItem = (addMore = false) => {
        let errors = validateItem();
        if (Object.keys(errors) <= 0) {
            const newPackage = packages.map(pkg => ({
                ...pkg,
                items: [...pkg.items]
            }));
            let newData = scanPackageData ? {
                id: newItem?.id || 'NEW',
                name: newItem?.name,
                ndc: newItem?.ndc?.trim(),
                description: newItem?.description?.trim(),
                quantity: newItem?.quantity?.trim(),
                unit: newItem?.unit || 'EA',
                number: newItem?.number?.trim(),
                tier: newItem?.tier,
                Price: newItem?.price
            } :
                {
                    id: newItem?.id,
                    name: newItem?.name,
                    number: newItem?.number?.trim(),
                }
            newPackage[newItem?.key]?.items?.push(newData)
            handleItems(newPackage)
            if (shipmentUpdate) {
                updateShipmentFunc(newPackage);
            }
            !addMore && openEditItemModal(false);
            if (addMore) {
                toast.success('Item added')
                let newData = scanPackageData
                    ? { key: newItem?.key, id: 'NEW', number: '', ndc: '', quantity: '', unit: '', name: 'Drug', tier: 0, storage: "" }
                    : { key: newItem?.key, id: 'NEW', name: 'Drug', number: '', storage: '' };
                setNewItem(newData);
            } else {
                setNewItem({});
            }
        }
    }

    const handleEditItem = (addMore) => {
        let errors = validateItem();
        if (Object.keys(errors).length <= 0) {
            if (shipmentUpdate) {
                swal({
                    text: `Are you sure you want to continue?`,
                    buttons: ['No', 'Yes'],
                    icon: 'warning',
                    dangerMode: true,
                }).then(async (status) => {
                    if (status) {
                        updatePackageData(addMore);
                        addCustomNDC(false)
                    }
                });
            } else {
                updatePackageData(addMore);
                addCustomNDC(false)
            }
        }
    };

    const updatePackageData = (addMore) => {
        const newPackage = packages.map(pkg => ({
            ...pkg,
            items: [...pkg.items]
        }));
        let editedData = scanPackageData
            ? {
                id: newItem?.id,
                name: newItem?.name,
                ndc: newItem?.ndc,
                description: newItem?.description?.trim(),
                quantity: newItem?.quantity,
                unit: newItem?.unit || "EA",
                number: newItem?.number?.trim(),
                tier: newItem?.tier,
                price: newItem?.price
            }
            : {
                id: newItem?.id,
                name: newItem?.name,
                number: newItem?.number,
            };
        if (newPackage[newItem?.key]) {
            newPackage[newItem?.key].items[newItem?.index] = editedData;
        }

        if (shipmentUpdate) {
            updateShipmentFunc(newPackage);
        } else {
            handleItems(newPackage);
        }

        if (packageErrors?.length > 0 && scanPackageData) {
            validatePackageData();
        }
        !addMore && openEditItemModal(false);
        if (addMore) {
            toast.success('Item updated')
            let newData = scanPackageData
                ? { index: null, key: newItem?.key, id: 'NEW', number: '', ndc: '', quantity: '', unit: '', name: 'Drug', tier: 0 }
                : { index: null, key: newItem?.key, id: 'NEW', name: 'Drug', number: '' };
            setNewItem(newData);
        } else {
            setNewItem({});
        }
    };

    const handleSearchNDC = async (NDC, quantity) => {
        if (!quantity?.trim() || quantity == 0) {
            setNewItemErrors(prev => ({ ...prev, quantity: "Required" }));
            return;
        }

        try {
            showSpinner(true);
            let numericQuantity = parseInt(quantity, 10) || 1;
            let formattedNDC = String(NDC).trim().replace(/-/g, "");
            let variations = [formattedNDC];
            if (formattedNDC.length > 11) {
                const res = await API.get("api", `/search/drug/${formattedNDC}`);
                if (res?.nadac_per_unit && res?.ndc_description && res?.pricing_unit) {
                    processFoundData(res, formattedNDC, numericQuantity);
                } else {
                    setNewItemErrors(prev => ({ ...prev, ndc: "NDC data not found!" }));
                }
                return;
            }

            if (formattedNDC.length === 10) {
                variations.push("0" + formattedNDC);
                variations.push(formattedNDC.slice(0, 5) + "0" + formattedNDC.slice(5));
                variations.push(formattedNDC.slice(0, 9) + "0" + formattedNDC.slice(9));
            }

            let foundData = null;
            for (let variant of variations) {
                const res = await API.get("api", `/search/drug/${variant}`);
                if (res?.nadac_per_unit && res?.ndc_description && res?.pricing_unit) {
                    foundData = res;
                    formattedNDC = variant;
                    break;
                }
            }

            if (foundData) {
                processFoundData(foundData, formattedNDC, numericQuantity);
            } else {
                setNewItemErrors(prev => ({ ...prev, ndc: "NDC data not found!" }));
            }
        } catch (error) {
            setNewItemErrors(prev => ({ ...prev, ndc: "NDC data not found!" }));
        } finally {
            showSpinner(false);
        }
    };

    // Helper function to process valid API response
    const processFoundData = (res, formattedNDC, numericQuantity) => {
        let tier = 0;
        let price = res.nadac_per_unit * numericQuantity;
        if (price <= 100) tier = 0;
        else if (price <= 5000) tier = 1;
        else if (price <= 20000) tier = 2;
        else if (price <= 40000) tier = 3;
        else tier = 4;
        setNewItem(prev => ({
            ...prev,
            tier,
            description: res.ndc_description,
            unit: res.pricing_unit,
            price: res.nadac_per_unit,
            ndc: formattedNDC
        }));
        setNewItemErrors(prev => ({ ...prev, ndc: "" }));
    };

    const handleStorageType = (key, storagekey) => {
        const newPackage = [...(packages || [])];
        if (!newPackage[key]) newPackage[key] = [];
        newPackage[key].package_type = storagekey;
        if (shipmentUpdate) {
            updateShipmentFunc(newPackage)
        } else {
            handleItems(newPackage);
        }
    };

    let showModalButtonFlag = scanPackageData ? ((newItem?.name !== 'Drug') || (newItem?.ndc && newItem?.description)) : true
    let showButtonsFlag = !isViewer((myShipper?.role || myShippers[0]?.role)) ? typeof showEditButtons === "boolean" ? showEditButtons : true : false;

    return (
        <>
            {showButtonsFlag && <section className='mt-4'>
                <h4>Package Count </h4>
                {
                    Object.keys(PackageCount).map((key, index) => {
                        return (
                            <button key={index}
                                className={`btn btn-md btn-${packageCount === PackageCount[key] ? 'success' : 'light'} me-2 mt-2`}
                                onClick={() => handlePackageCount(key)}
                            >{PackageCount[key]}</button>
                        )
                    })
                }
            </section>}
            <div className='mt-4'>
                <Row className="mb-2 d-flex  align-items-center" >
                    <Col className="auto">
                        <h4 className='mt-2'>Package Contents {`(${packages?.length} / 5)`}</h4>
                    </Col>
                </Row>
                <DragDropContext onDragEnd={onDragEnd}>
                    {packages?.length > 0 &&
                        packages.map((pkg, key) => (
                            <Droppable droppableId={`${key}`} key={key}>
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        <Card>
                                            <Card.Header>
                                                <Row>
                                                    <Col className="d-flex gap-2 align-items-center">
                                                        <h4 className="card-header-title  me-0 ">Package {key + 1}</h4>
                                                        {
                                                            Object.keys(StorageType).map((storagekey, index) => {
                                                                const packageStorage = packages[key]?.package_type;
                                                                return (
                                                                    <>
                                                                        {
                                                                            <button key={index}
                                                                                disabled={greenPhox || !showButtonsFlag}
                                                                                className={`btn btn-sm btn-${StorageType[packageStorage] === StorageType[storagekey] ? "success" : 'light'} py-2 px-3 mx-1`}
                                                                                onClick={() => handleStorageType(key, storagekey)}>
                                                                                {packages[key].package_type === StorageType[storagekey] && <i className="fe fe-check-circle me-2"></i>}    {StorageType[storagekey]}
                                                                            </button >
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </Col>
                                                    {showButtonsFlag && (
                                                        <Col className="col-auto mx-1 mt-1">
                                                            {packages.length > 1 && (
                                                                <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => removePackages(key)}>
                                                                    <i className="fe fe-trash"></i>
                                                                </button>
                                                            )}
                                                            <button
                                                                className="btn btn-sm btn-outline-secondary"
                                                                onClick={() => {
                                                                    openEditItemModal(true);
                                                                    let newData = scanPackageData
                                                                        ? { key, id: "NEW", number: '', ndc: '', quantity: '', unit: '', name: 'Drug', tier: '' }
                                                                        : { key, id: 'NEW', name: 'Drug', number: '' };
                                                                    setNewItem(newData);
                                                                }}
                                                            >
                                                                <i className="fe fe-plus"></i> Add Item
                                                            </button>
                                                        </Col>
                                                    )}
                                                </Row>
                                            </Card.Header>
                                            <Table size="sm" className="mb-0" responsive>
                                                <thead>
                                                    <tr>
                                                        {showButtonsFlag && <th className="m-0 p-0 text-center"></th>}
                                                        <th>#</th>
                                                        <th>Product Type</th>
                                                        {scanPackageData && (
                                                            <>
                                                                <th>NDC <span className="text-danger">*</span></th>
                                                                {!hideName && <th>Product Name <span className="text-danger">*</span></th>}
                                                                <th>quantity <span className="text-danger">*</span></th>
                                                                <th>Unit <span className="text-danger">*</span></th>
                                                            </>
                                                        )}
                                                        <th>Reference Number {scanPackageData && <span className="text-danger">*</span>}</th>
                                                        {scanPackageData && <th className="text-center">PhoxTail Tier</th>}
                                                        {showButtonsFlag && <th className="text-center">Action</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pkg.items.map((item, index) => (
                                                        <Draggable
                                                            isDragDisabled={!showButtonsFlag}
                                                            key={`${key}-${index}`}
                                                            draggableId={`${key}-${index}`}
                                                            index={index}
                                                        >
                                                            {(provided) => (
                                                                <tr
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className={getErrorMessageForRow(key, index) ? "table-danger" : ""}
                                                                >
                                                                    {showButtonsFlag && (
                                                                        <td className="m-0 p-0 text-center border-end">
                                                                            <img src="/img/drag.svg" alt="drag-svg" height={'20'} />
                                                                        </td>
                                                                    )}
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.name}</td>
                                                                    {scanPackageData && (
                                                                        <>
                                                                            <td className={getErrorMessage(key, index, 'ndc') ? "mt-4" : ""}>
                                                                                <Col className="col-auto">{item?.ndc || '--'}</Col>
                                                                                <Col className="col-auto">
                                                                                    <FormError error={getErrorMessage(key, index, 'ndc')} />
                                                                                </Col>
                                                                            </td>
                                                                            {!hideName && (
                                                                                <td>
                                                                                    <Col>{item?.description || '--'}</Col>
                                                                                    <Col className="col-auto"><FormError error={getErrorMessage(key, index, 'description')} /></Col>
                                                                                </td>
                                                                            )}
                                                                            <td className={getErrorMessage(key, index, 'quantity') ? "mt-4" : ""}>
                                                                                {item?.quantity || '--'}
                                                                                <Col><FormError error={getErrorMessage(key, index, 'quantity')} /></Col>
                                                                            </td>
                                                                            <td>{item?.unit || "EA"}</td>
                                                                        </>
                                                                    )}
                                                                    <td className={getErrorMessage(key, index, 'number') ? "mt-4" : ""}>
                                                                        <Col className="col-auto">{item?.number || '--'}</Col>
                                                                        <Col className="col-auto">
                                                                            <FormError error={getErrorMessage(key, index, 'number')} />
                                                                            <FormError error={getErrorMessage(key, index, 'duplicateReferenceNumber')} />
                                                                        </Col>
                                                                    </td>
                                                                    {scanPackageData && (
                                                                        <td className="text-center">
                                                                            <img className="me-2" src={getTier(item?.tier || 0)} alt="tier-img" height={30} />
                                                                        </td>
                                                                    )}
                                                                    {showButtonsFlag && (
                                                                        <td className="text-center">
                                                                            <button
                                                                                className="btn btn-sm btn-light mb-2 mx-1"
                                                                                onClick={() => {
                                                                                    setNewItem({
                                                                                        key,
                                                                                        index,
                                                                                        id: item.id,
                                                                                        number: item.number,
                                                                                        ndc: item.ndc,
                                                                                        description: item.description,
                                                                                        quantity: item.quantity,
                                                                                        unit: item.unit,
                                                                                        name: item.name,
                                                                                        tier: item.tier,
                                                                                    });
                                                                                    openEditItemModal(true);
                                                                                }}
                                                                            >
                                                                                <i className="fe fe-edit"></i>
                                                                            </button>
                                                                            {pkg.items.length > 1 && (
                                                                                <button className="btn btn-sm btn-outline-secondary mb-2" onClick={() => removeShipmentItem(index, key)}>
                                                                                    <i className="fe fe-trash"></i>
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </tbody>
                                            </Table>
                                        </Card>
                                    </div>
                                )}
                            </Droppable>
                        ))}
                </DragDropContext>

            </div >
            <Modal show={editItemModal}>
                <Modal.Header className="d-flex justify-content-center">
                    <h4>
                        {(newItem?.key !== undefined && newItem?.key !== null &&
                            newItem?.index !== undefined && newItem?.index !== null) ? "Edit Item" : "Add Item"}
                    </h4>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12} className="mb-3">
                            <label>Product Type  </label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                value={{
                                    label: newItem?.name || 'Drug',
                                    value: newItem?.id || 'NEW',
                                }}
                                placeholder='Drug'
                                loadOptions={searchProducts}
                                onChange={(e) =>
                                    setNewItem((prev) => ({ ...prev, name: e.label, id: e.value }))
                                }
                            />
                        </Col>
                        <Col lg={12} className="mb-3">
                            <label>Reference Number {scanPackageData && <span className="text-danger">*</span>} </label>
                            <input
                                className={`${getErrorMessage('number') && "mt-4"}  form-control`}
                                key={"index"}
                                type='text'
                                name='number'
                                placeholder='e.g. RX32443244'
                                value={newItem?.number}
                                onChange={(e) =>
                                    setNewItem((prev) => ({ ...prev, number: e.target.value?.trim() }))
                                }
                            />
                            <FormError error={newItemErrors?.number} />
                        </Col>
                        {scanPackageData && <>
                            {newItem?.name === 'Drug' &&
                                <>
                                    <Col lg={12} className="mb-3">
                                        <label>Quantity <span className="text-danger">*</span>  </label>
                                        <Row className="border mx-1 rounded">
                                            <Col lg={10} md={10} sm={10} xs={10} className="ps-0" >
                                                <input
                                                    className={`form-control border-0 ms-0 ps-2`}
                                                    key={"index"}
                                                    type='text'
                                                    name='quantity'
                                                    placeholder='e.g. 100'
                                                    value={newItem?.quantity}
                                                    onChange={(e) => {
                                                        setNewItem((prev) => ({ ...prev, quantity: e.target.value, unit: '', description: '', tier: 0 })); setNewItemErrors((prev) => ({ ...prev, quantity: '' }))
                                                    }}
                                                />
                                            </Col>
                                            <Col lg={2} md={2} sm={2} xs={2} >
                                                <input
                                                    disabled
                                                    className={`form-control border-0 text-end  bg-white`}
                                                    key={newItem?.unit}
                                                    type='text'
                                                    name='unit'
                                                    value={newItem?.unit || 'EA'}
                                                />
                                            </Col>
                                        </Row>
                                        <FormError error={newItemErrors?.quantity} />


                                    </Col>
                                    <Col lg={12} className="mb-3">
                                        <label>NDC  <span className="text-danger">*</span> </label>
                                        <Row className="border mx-1 rounded ">
                                            <Col lg={11} md={11} sm={11} xs={11} className="p-0 " onWheel={(e) => e.target.blur()}>
                                                <input
                                                    className={`form-control border-0 ms-0 ps-3`}
                                                    key={"index"}
                                                    name='ndc'
                                                    placeholder='e.g. 12345-6789-10'
                                                    value={newItem?.ndc}
                                                    onChange={(e) =>
                                                        setNewItem((prev) => ({ ...prev, ndc: e.target.value?.replace(/[^0-9]/g, ''), unit: '', description: '', tier: 0 }))
                                                    }
                                                />
                                            </Col>
                                            <Col lg={1} md={1} sm={1} xs={1} className="ms-0 px-0 d-flex justify-content-end align-item-end">
                                                <button className="btn btn-outline-secondary border-0  py-2 "
                                                    disabled={!newItem?.ndc}
                                                    onClick={() => {
                                                        handleSearchNDC(newItem?.ndc, newItem?.quantity)
                                                    }}>
                                                    <i className="fe fe-search me-1"></i>
                                                </button>
                                            </Col>
                                        </Row>

                                        <div className="d-flex">
                                            <FormError error={newItemErrors?.ndc} />
                                            {(newItemErrors?.ndc === "NDC data not found!" && !customNDC) && <span className="ms-auto mt-2 fs-sm text-muted cursor-pointer" onClick={() => addCustomNDC(true)}>   <i className="fe fe-plus"></i> Enter Manually </span>}
                                        </div>

                                    </Col>

                                </>

                            }
                            <Spinner display={spinner}>
                                {
                                    newItem?.name === 'Drug' && <>
                                        {
                                            ((newItem?.description && newItem?.unit) || customNDC) ?
                                                <>
                                                    <Col lg={12} className="mb-3" >
                                                        <label>Product Name<span className="text-danger">*</span> </label>
                                                        <input
                                                            disabled={!customNDC}
                                                            className={`form-control`}
                                                            key={"index"}
                                                            type='text'
                                                            name='description'
                                                            placeholder='e.g. RINVOQ ER'
                                                            value={newItem?.description}
                                                            onChange={(e) =>
                                                                setNewItem((prev) => ({ ...prev, description: e.target.value }))
                                                            }
                                                        />
                                                        <FormError error={newItemErrors?.name} />
                                                    </Col>
                                                    <Col lg={12} className="my-3">
                                                        <label>Tier<span className="text-danger">*</span> </label>
                                                        <Form.Select value={newItem?.tier} onChange={(e) => setNewItem((prev) => ({ ...prev, tier: e.target.value }))}>
                                                            <option key={0} disabled value={0}>Tier 0 PhoxTail Guarantee: $100 </option>
                                                            <option key={1} value={1}>Tier 1 PhoxTail Guarantee: Upto $5,000 </option>
                                                            <option key={2} value={2}>Tier 2 PhoxTail Guarantee: Upto $20,000</option>
                                                            <option key={3} value={3}>Tier 3 PhoxTail Guarantee: Upto $40,000 </option>
                                                            <option key={4} value={4}>Tier 4 PhoxTail Guarantee: Upto $60,000 </option>
                                                        </Form.Select>
                                                    </Col>
                                                </>
                                                :
                                                <div className="d-flex justify-content-center mt-3 text-muted">
                                                    {newItem.ndc && <h4>Please search the NDC data </h4>}
                                                </div>
                                        }
                                    </>
                                }
                            </Spinner>
                        </>}
                    </Row>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-start">
                    {
                        showModalButtonFlag &&
                        <>
                            <button className="btn btn-dark" onClick={() => { (newItem?.index !== null && newItem?.index !== undefined) ? handleEditItem() : handleAddItem() }}> Save & Close </button>
                            {
                                !shipmentUpdate &&
                                <button className="btn btn-outline-secondary " onClick={() => { (newItem?.index !== null && newItem?.index !== undefined) ? handleEditItem(true) : handleAddItem(true) }} >Save & New</button>

                            }
                        </>
                    }
                    <button className="btn btn-outline-secondary" onClick={() => { openEditItemModal(false); setNewItemErrors({}); addCustomNDC(false) }} > Cancel </button>
                </Modal.Footer>
            </Modal >
        </>
    )
};

export default PackageSection;
